export default __webpack_public_path__ + "static/media/real-life-SN2.57c39fb9.mp3";